import { render } from "./SupplierShowComponent.vue?vue&type=template&id=02526e02"
import script from "./SupplierShowComponent.vue?vue&type=script&lang=js"
export * from "./SupplierShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Supplier/SupplierShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02526e02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02526e02', __exports__)) {
    api.reload('02526e02', __exports__)
  }
  
  module.hot.accept("./SupplierShowComponent.vue?vue&type=template&id=02526e02", () => {
    api.rerender('02526e02', render)
  })

}


export default __exports__